import { useEffect, useState } from "react";

export function useIsMobile() {
    const [mobile, setMobile] = useState(window.innerWidth < 640);
    useEffect(() => {
        const fn = () => setMobile(window.innerWidth < 640);
        window.addEventListener("resize", fn);
        return () => window.removeEventListener("resize", fn);
    }, []);
    return mobile;
}